module.exports = __webpack_public_path__ + "img/hacker.98cf0fc2.jpg";